import React, { useState } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import i18n from 'i18next';

const LanguageSelector = () => {
  const changeLanguage = (ln) => {
    if (ln === 'IT') i18n.changeLanguage('it');
    if (ln === 'GB') i18n.changeLanguage('en');
    if (ln === 'FR') i18n.changeLanguage('fr');
    if (ln === 'DE') i18n.changeLanguage('de');
  };
  const currentLanguage = (ln) => {
    if (ln === 'en') return 'GB';
    if (ln === 'fr') return 'FR';
    if (ln === 'de') return 'DE';
    return 'IT';
  };
  const [selectedLanguage, setSelectedLanguage] = useState(
    currentLanguage(i18n.language)
  );

  return (
    <ReactFlagsSelect
      className="menu-flags"
      selected={selectedLanguage}
      onSelect={(code) => {
        setSelectedLanguage(code);
        changeLanguage(code);
      }}
      customLabels={{ IT: 'IT', GB: 'EN', FR: 'FR', DE: 'DE' }}
      countries={['IT', 'GB', 'FR', 'DE']}
    />
  );
};

export default LanguageSelector;
